import React from "react";
import PropTypes from "prop-types";
import { Button } from "rsuite";
import NoResultsIcon from "../../assets/img/no-results.png";

const PriceCheckEmptyState = ({ onSearchAgain }) => (
  <div className="empty-state">
    <img
      src={NoResultsIcon}
      alt="no results icon"
      className="no-results-icon"
    />
    <h4>Sorry we could not find any results</h4>
    <p>Please adjust your search and try again.</p>
    <Button appearance="primary" onClick={onSearchAgain}>
      Search again
    </Button>
  </div>
);

PriceCheckEmptyState.propTypes = {
  onSearchAgain: PropTypes.func.isRequired,
};

export default PriceCheckEmptyState;
